import { AiTool, AiStepSchema } from '@feedyou/schema'

import { Search } from '../../../types'
import { createConfigs, searchMutableObject } from '../../../../../features/flowSearch'

export const search: Search<AiStepSchema> = (step, query) => {
  const aiStepSearchResults = searchMutableObject(
    step,
    query,
    { type: 'step', id: step.id },
    createConfigs({
      id: ['id'],
      storage: ['outputs.%key%.storage'],
      text: [
        'goal',
        'instructions',
        'condition',
        'input.%key%.text',
        'input.%key%.callId',
        'input.%key%.output',
        'input.%key%.content',
        'input.%key%.items.%key%.text',
        'input.%key%.items.%key%.fileId',
        'input.%key%.items.%key%.fileUrl',
        'input.%key%.items.%key%.fileData',
        'input.%key%.items.%key%.fileName',
        'input.%key%.items.%key%.imageUrl'
      ]
    })
  )

  const toolSubstepSearchResults = step.tools?.flatMap(searchInTool(query)) ?? []

  return [...aiStepSearchResults, ...toolSubstepSearchResults]
}

export function searchInTool(query: string) {
  return (step: AiTool) =>
    searchMutableObject(
      step,
      query,
      { type: 'tool', id: step.id! },
      createConfigs({
        id: ['id'],
        dialog: ['action.dialog'],
        storage: ['action.storage'],
        text: ['name', 'parameters', 'description', 'action.code', 'condition']
      })
    )
}
